import * as React from "react";
import { Spin } from "antd";
import { CustomModal } from "../common/CustomModal";
import { EditForm } from "./EditForm";

export class EditModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      data: [],
      recordDetails: {},
      isLoading: false, // Fixme this should be true
      closable: true,
    };
  }

  componentDidMount() {
    if (this.props.refx) {
      this.props.refx(this);
    }
  }

  handleOk = (e) => {
    this.setState({
      visible: false,
    });
  };

  handleCancel = (e) => {
    this.hide();
  };

  show() {
    this.setState({
      visible: true,
    });
  }

  hide() {
    this.setState({
      visible: false,
    });
    this.props.onClose();
  }

  render() {
    const { course_id } = this.props;

    return (
      <CustomModal
        width="1000px"
        closable={this.state.closable}
        visible={this.state.visible}
        title="Edit Module"
        onOk={this.handleOk}
        onCancel={this.handleCancel}
        footer={null}
        destroyOnClose={true}
        maskClosable={false}
        bodyStyle={{ minHeight: "350px" }}
      >
        {this.state.isLoading ? (
          <div style={{ justifyContent: "center" }}>
            <Spin />
          </div>
        ) : (
          <EditForm
            data={this.props.moduleSelectedData}
            onSubmit={this.props.onSubmit}
            handleCancel={this.handleCancel}
            course_id={course_id}
          />
        )}
      </CustomModal>
    );
  }
}
